import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Icons } from '@/configurations';

import '@/companys/ttl/assets/styles/components/instrument/market-add-watchlist-dialog.scss'

import { userActions } from '@/actions/user';
import Tips from '@/components/Tips/Tips';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { LOADING_TYPE } from '@/constants/app';
import { SERVICES_RESP } from '@/configurations';
import { WINVEST_PARAMS_JSON_FLAG } from '@/constants/win-vest'

class MarketAddWatchlistDialog extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showInput: false,
            errorMessage: "",
            load: false,
            isLoadingConfirm: false,
            currentSeleteWatchlist: [],
        }
    }
    render() {
        const { watchlist, language,theme,subTab } = this.props
        const { showInput, load, isLoadingConfirm, errorMessage } = this.state
        return (
            <div className='market-add-watchlist' onClick={() => { this.setState({ errorMessage: "" }) }} >
                <LoadingLayer type={LOADING_TYPE.BIG_IMG} load={load} />
                <div className='maw-group'>
                    {watchlist.custom.filter(item => {return item.title != subTab?.title}).map((item, index) => {
                        return (
                            <div className='maw-group-select' key={index} >
                                <input className='maw-select-input' type='checkbox' onChange={() => this.handleCheckBoxSelect(item.title)} id={item.title}  ></input>
                                <label className='maw-select-title' for={item.title} >{item.title} </label>
                            </div>
                        )
                    })}
                </div>


                <div className='maw-add-new-group' >
                    <div className='add-new-group' style={{ paddingTop: showInput ? '0px' : '30px', color: showInput ? '#1780c2' : '' }}>
                        <span className='ang-text' onClick={() => this.handleShowInput()} >{language.market_add_new_watchlist_group}  </span>
                    </div>
                    <div className='ang-group' >
                        <input className='ang-input' style={{ opacity: showInput ? '1' : '0', visibility: showInput ? '' : 'hidden',
                        backgroundColor:theme==='light'?'#e3eaf2':'',color:theme==='light'?'#000':'' }}
                            placeholder={language.market_watchlist_name}
                            ref={e => this.angInputRef = e}
                            disabled={isLoadingConfirm ? true : false}
                            onKeyDown={e => e.keyCode === 13 ? this.handleAddWatchlistGroup() : ''}
                            autoFocus='autoFocus'></input>
                        <div className='ang-button' style={{ opacity: showInput ? '1' : '0', visibility: showInput ? '' : 'hidden',color:theme==='light'?'#fff':'' }}
                            onClick={isLoadingConfirm ? () => { } : () => this.handleAddWatchlistGroup()}
                        > {isLoadingConfirm ? <Icons.Loading /> : language['common_confirm']} </div>
                    </div>
                    <div className='ang-error'>
                        {errorMessage && <Tips isNoBgColor>{language[errorMessage] ?? errorMessage}</Tips>}
                    </div>
                </div>

                <div className='maw-button' style={{ marginTop: errorMessage ? '25px' : '',color:theme==='light'?'#fff':'' }} >
                    <div className='maw-cancel-button' onClick={() => this.props.onClose()}  >{language.common_cancel} </div>
                    <div className='maw-confirm-button' onClick={() => this.handleConfirmButton()} >{language.common_confirm}</div>
                </div>
            </div>
        )
    }
    componentDidMount() {

    }
    componentWillUnmount() {
        this.setState = () => {
            return
        }
    }

    handleConfirmButton = () => {
        const { rows, watchlist } = this.props
        const { currentSeleteWatchlist } = this.state
        if (rows.length <= 0 || currentSeleteWatchlist.length <= 0) return
        this.setState({ load: true })
        if (currentSeleteWatchlist.length >= 1) {
            currentSeleteWatchlist.forEach((item) => {
                let needAddArr = []
                rows.forEach(item => {
                    let stock = item.symbol.split('.')[1] + ':' + item.symbol.split('.')[0]
                    needAddArr.push(stock)
                });
                let flagStock = watchlist.custom.filter(fitem => { return fitem.title == item })
                flagStock[0].flaggings.forEach(item => {
                    needAddArr.push(item.id + ':' + item.market)
                })
                const Pitem = needAddArr.join(',')
                const params = {
                    [WINVEST_PARAMS_JSON_FLAG.KEY]: WINVEST_PARAMS_JSON_FLAG.VALUE,
                    data: [
                        {
                            name: flagStock[0].name,
                            items: Pitem,
                        }
                    ]
                }
                this.props.manageWatchList(params, res => {
                    this.setState({ load: false }, () => {
                        this.props.onClose()
                        this.props.getWatchlistAndCloseCheckBoxfun()
                    })
                })
            })

        } else {
            return
        }
    }

    handleCheckBoxSelect = (WatchlistName) => {
        let { currentSeleteWatchlist } = this.state
        if (currentSeleteWatchlist.indexOf(WatchlistName) != -1) {
            currentSeleteWatchlist.splice(currentSeleteWatchlist.indexOf(WatchlistName), 1)
        } else {
            currentSeleteWatchlist.push(WatchlistName)
        }
        this.setState({ currentSeleteWatchlist }, () => {
        })
    }

    handleShowInput() {
        this.setState({ showInput: !this.state.showInput })
    }

    handleAddWatchlistGroup() {
        const newTitle = this.angInputRef.value
        if (newTitle) {
            this.setState({ load: true, isLoadingConfirm: true })
            const { language } = this.props
            const params = {
                title: newTitle,
                ids: '',
                template: 'watchlist2'
            }
            this.props.addNewWatchlist(params, res => {
                this.handleResponse(res)
            })
        }
    }
    handleResponse = (res, message) => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
            const { userInfo } = this.props
            this.props.getWatchlist({ uuid: userInfo.id }, response => {
                this.setState({ load: false, isLoadingConfirm: false, showInput: false }, () => {
                    this.angInputRef.value = ''
                })
            })
        } else {
            const errorMessage = res?.result ?? ''
            this.setState({ errorMessage, load: false, isLoadingConfirm: false })
        }
    }
}

export default connect(
    state => ({
        language: state.app.language,
        watchlist: state.user.watchlist,
        userInfo: state.user.userInfo,
        theme: state.app.theme,
    }),
    dispatch => ({
        addNewWatchlist: (p, c) => dispatch(userActions.addNewWatchlistAction(p, c)),
        manageWatchList: (p, c) => dispatch(userActions.manageWatchlistAction(p, c)),
        getWatchlist: (p, c) => dispatch(userActions.getInstrumentWatchlistAction(p, c)),
    }))(MarketAddWatchlistDialog)